import * as errors from '@attain-apps/errors'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Feature } from '../feature'
import * as models from '../models'

/**
 * TODO:
 */
export const onUploadRequest = store.effects.create(
  // NOTE: Types will be inferred from feature when registered
  (feature: Feature) =>
    feature.actions.upload.request.observe().pipe(
      rxjs.mergeMap(action => {
        const { file, purpose, context, qualifier } = action.data
        if (!models.FileRequest.isSupportedUploadFile(file)) {
          const { extension } = models.FileRequest.getFileInfo(file)
          return rxjs.of(
            feature.actions.upload.error.from(action).create({
              error: new errors.ValidationError({
                reason: `Unsupported upload file type.`,
                type: 'file',
                value: extension,
              }),
              request: action.data,
            }),
          )
        }

        /**
         * Result of invoking the optional name resolver. May be a `string`, an
         * `Observable<string>`, or `undefined` if no resolver was provided.
         */
        const fileNameResolver = action.data.nameResolver?.(file)

        /**
         * Normalized observable that emits the resolved file name exactly once.
         * Falls back to the original file name if no resolver was provided.
         */
        const fileName$ = (
          fileNameResolver instanceof rxjs.Observable
            ? fileNameResolver
            : rxjs.of(fileNameResolver ?? file.name)
        ).pipe(rxjs.take(1))

        // Step 1: Get presigned POST URL
        return fileName$.pipe(
          rxjs.switchMap(fileName =>
            feature.api
              .getUploadRequest({
                context,
                file,
                fileName,
                purpose,
                qualifier,
              })
              .pipe(
                rxjs.map(() =>
                  feature.actions.upload.success.from(action).create({
                    input: {
                      context,
                      file,
                      purpose,
                      qualifier,
                    },
                  }),
                ),
                rxjs.catchError(() =>
                  rxjs.of(
                    feature.actions.upload.error.from(action).create({
                      error: new Error('Failed to upload file to backend'),
                      request: action.data,
                    }),
                  ),
                ),
              ),
          ),
        )
      }),
    ),
)
